<template>
  <div style="padding: 10px">
    <!-- 搜索区域 -->
    <div style="margin: 10px 0">
      <el-button type="primary" style="margin-left: 5px" @click="load">查询</el-button>
      <el-button style="margin-left: 5px" @click="resetData">重置</el-button>
      <!-- 一键送券按钮保留 -->
      <el-button type="success" style="margin-left: 5px" @click="sendLegacy">一键送券</el-button>
    </div>

    <!-- 表格区域 -->
    <el-table
        v-loading="loading"
        :data="tableData"
        border
        stripe
        style="width: 100%">
      <el-table-column
          prop="accountName"
          label="角色名"
          show-overflow-tooltip>
      </el-table-column>
      <el-table-column
          prop="roleId"
          label="角色ID"
          show-overflow-tooltip>
      </el-table-column>
      <el-table-column
          prop="legacyCount"
          label="送券数量"
          show-overflow-tooltip>
      </el-table-column>
      <el-table-column
          prop="coin"
          label="咸鱼币数量"
          show-overflow-tooltip>
      </el-table-column>
      <el-table-column
          prop="syncTime"
          label="同步时间"
          show-overflow-tooltip>
      </el-table-column>
      <el-table-column
          prop="status"
          label="状态"
          show-overflow-tooltip>
        <template #default="scope">
          <el-tag :type="getStatusTagType(scope.row.status)">
            {{ getStatusText(scope.row.status) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180px" v-if="this.userId === 1">
        <template #default="scope">
          <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
          <!-- 保留结算按钮 -->
          <el-button size="mini" type="primary" @click="handleSettlement(scope.row)">结算</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页区域 -->
    <div style="margin: 10px 0">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 20, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </div>

    <!-- 编辑表单 -->
    <el-dialog :title="dialogTitle" v-model="dialogVisible" width="50%">
      <el-form :model="form" ref="formRef" :rules="rules" label-width="120px">
        <el-form-item label="残券数量" prop="legacyCount">
          <el-input-number v-model="form.legacyCount" :min="0" style="width: 100%"/>
        </el-form-item>

        <el-form-item label="咸鱼币数量" prop="coin">
          <el-input-number v-model="form.coin" :min="0" style="width: 100%"/>
        </el-form-item>

        <el-form-item label="状态" prop="status">
          <el-select v-model="form.status" placeholder="请选择状态" style="width: 100%">
            <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
          <span class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="save">确 定</el-button>
          </span>
      </template>
    </el-dialog>

    <!-- 结算弹窗 -->
    <el-dialog title="残券结算" v-model="settlementDialogVisible" width="500px">
      <el-form :model="settlementForm" ref="settlementFormRef" :rules="settlementRules" label-width="100px">
        <el-form-item label="残券价格" prop="price">
          <el-input-number
              v-model="settlementForm.price"
              :min="0"
              :precision="2"
              style="width: 100%"
              placeholder="请输入每张残券的价格（元/万）"
              @change="calculatePayableAmount">
          </el-input-number>
        </el-form-item>

        <el-form-item label="残券数量">
          <el-input
              v-model="settlementForm.legacyCount"
              readonly
              style="width: 100%">
            <template #append>张</template>
          </el-input>
        </el-form-item>

        <el-form-item label="应付金额">
          <el-input
              v-model="settlementForm.payableAmount"
              readonly
              style="width: 100%">
            <template #append>元</template>
          </el-input>
        </el-form-item>
      </el-form>
      <template #footer>
          <span class="dialog-footer">
            <el-button @click="settlementDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="saveSettlement">确 定</el-button>
          </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  name: 'LegacySoldManagement',
  components: {},
  data() {
    return {
      dialogVisible: false,
      settlementDialogVisible: false,
      dialogTitle: '编辑',

      // 主表单
      form: {
        id: '',
        legacyCount: 0,
        coin: 0,
        status: 0
      },

      // 结算表单
      settlementForm: {
        id: '',
        price: 0,
        legacyCount: 0,
        payableAmount: 0,
        accountName: '',
        roleId: ''
      },

      formRef: null,
      settlementFormRef: null,
      userId: '',
      loading: true,

      search: {},
      query: {},
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],

      // 主表单验证规则
      rules: {
        legacyCount: [
          {required: true, message: '请输入残券数量', trigger: 'blur'}
        ],
        status: [
          {required: true, message: '请选择状态', trigger: 'change'}
        ]
      },

      // 结算表单验证规则
      settlementRules: {
        price: [
          {required: true, message: '请输入残券价格', trigger: 'blur'},
          {type: 'number', min: 0, message: '价格不能为负数', trigger: 'blur'}
        ]
      },

      // 状态选项
      statusOptions: [
        {label: '正常', value: 0},
        {label: '停用', value: 1},
        {label: '删除', value: 2}
      ]
    }
  },
  created() {
    // 初始化用户信息
    let userStr = sessionStorage.getItem("user") || "{}"
    let user = JSON.parse(userStr)
    this.userId = user.id;

    // 加载数据
    this.load();
  },
  methods: {
    // 重置搜索条件
    resetData() {
      this.search = {};
      this.currentPage = 1;
      this.load();
    },

    // 格式化数字，保留两位小数
    formatNumber(num) {
      return parseFloat(num.toFixed(2));
    },

    // 获取当前时间
    getCurrentTime() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    // 发送残券同步请求的方法
    sendLegacy() {
      this.loading = true;

      request.get("/xyzwws/websocket/legacySync")
          .then(res => {
            this.loading = false;
            if (res.code === '0') {
              this.$message({
                type: "success",
                message: res.msg || "同步请求发送成功"
              });
              // 可选：发送成功后刷新数据
              this.load();
            } else {
              this.$message({
                type: "error",
                message: res.msg || "同步请求发送失败"
              });
            }
          })
          .catch(error => {
            this.loading = false;
            console.error("同步请求错误:", error);
            this.$message.error("网络错误，同步请求失败");
          });
    },

    // 编辑按钮
    handleEdit(row) {
      this.dialogTitle = '编辑';
      this.form = {
        id: row.id,
        legacyCount: row.legacyCount || 0,
        coin: row.coin || 0,
        status: row.status || 0
      };
      this.dialogVisible = true;
    },

    // 结算按钮
    handleSettlement(row) {
      const legacyCount = parseInt(row.legacyCount || 0);
      this.settlementForm = {
        id: row.id,
        price: 0,
        legacyCount: legacyCount,
        payableAmount: 0,
        accountName: row.accountName || '',
        roleId: row.roleId || ''
      };
      this.settlementDialogVisible = true;
    },

    // 计算应付金额
    calculatePayableAmount() {
      const price = parseFloat(this.settlementForm.price || 0);
      const legacyCount = parseInt(this.settlementForm.legacyCount || 0);

      if (price > 0 && legacyCount > 0) {
        const payableAmount = (legacyCount * price / 10000.0);
        this.settlementForm.payableAmount = this.formatNumber(payableAmount);
      } else {
        this.settlementForm.payableAmount = 0;
      }
    },

    // 保存结算
    saveSettlement() {
      this.$refs.settlementFormRef.validate((valid) => {
        if (valid) {
          this.loading = true;

          // 1. 创建交易记录
          const transactionData = {
            accountName: this.settlementForm.accountName,
            roleId: this.settlementForm.roleId,
            price: this.formatNumber(this.settlementForm.payableAmount),
            type: 2, // 代售未结算
            event: `卖券${this.settlementForm.legacyCount}，单价${this.settlementForm.price}元/万`,
            createTime: this.getCurrentTime()
          };

          // 2. 更新残券数量为0
          const settlementData = {
            id: this.settlementForm.id,
            legacyCount: 0
          };

          // 先创建交易记录
          request.post("/legacySoldOrder/save", transactionData)
              .then(res => {
                if (res.code === '0') {
                  // 再更新残券数量
                  return request.post("/legacySold/update", settlementData);
                } else {
                  throw new Error(res.msg || '创建交易记录失败');
                }
              })
              .then(res => {
                this.loading = false;
                if (res.code === '0') {
                  this.$message({
                    type: "success",
                    message: "结算成功，已创建交易记录"
                  });
                  this.settlementDialogVisible = false;
                  this.load();
                } else {
                  this.$message({
                    type: "error",
                    message: res.msg || "结算失败"
                  });
                }
              })
              .catch(error => {
                this.loading = false;
                console.error('结算错误:', error);
                this.$message.error(error.message || "网络错误，结算失败");
              });
        }
      });
    },

    // 保存（编辑）
    save() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.loading = true;

          // 深拷贝表单数据
          const formData = JSON.parse(JSON.stringify(this.form));

          request.post("/legacySold/update", formData).then(res => {
            this.loading = false;
            if (res.code === '0') {
              this.$message({
                type: "success",
                message: res.msg || "编辑成功"
              });
              this.dialogVisible = false;
              this.load(); // 刷新数据
            } else {
              this.$message({
                type: "error",
                message: res.msg || "编辑失败"
              });
            }
          }).catch(error => {
            this.loading = false;
            this.$message.error("网络错误，编辑失败");
          });
        } else {
          return false;
        }
      });
    },

    // 加载数据
    load() {
      this.loading = true;

      // 构建查询参数
      const params = {
        current: this.currentPage,
        size: this.pageSize
      };

      // 添加搜索条件
      Object.keys(this.search).forEach(key => {
        if (this.search[key] !== '' && this.search[key] !== undefined && this.search[key] !== null) {
          params[key] = this.search[key];
        }
      });

      request.get("/legacySold/listPage", {
        params: params
      }).then(res => {
        this.loading = false;

        if (res.code === '0') {
          // 处理返回的数据结构
          let data = res.data;

          // 如果返回的是数组
          if (Array.isArray(data)) {
            this.tableData = data;
            this.total = data.length;
          }
          // 如果返回的是分页结构
          else if (data && data.records) {
            this.tableData = data.records || [];
            this.total = data.total || 0;
          }
          // 如果是对象但包含list
          else if (data && data.list) {
            this.tableData = data.list || [];
            this.total = data.total || 0;
          } else {
            this.tableData = [];
            this.total = 0;
          }
        } else {
          this.$message.error(res.msg || '加载失败');
          this.tableData = [];
          this.total = 0;
        }
      }).catch(error => {
        this.loading = false;
        this.$message.error('网络错误，加载失败');
        this.tableData = [];
        this.total = 0;
      });
    },

    // 获取状态标签类型
    getStatusTagType(status) {
      switch (parseInt(status)) {
        case 0:
          return 'success';
        case 1:
          return 'warning';
        case 2:
          return 'danger';
        default:
          return 'info';
      }
    },

    // 获取状态文本
    getStatusText(status) {
      const option = this.statusOptions.find(item => item.value === parseInt(status));
      return option ? option.label : '未知';
    },

    // 改变每页显示数量
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.currentPage = 1;
      this.load();
    },

    // 改变当前页码
    handleCurrentChange(pageNum) {
      this.currentPage = pageNum;
      this.load();
    }
  }
}
</script>

<style scoped>
/* 可选的样式调整 */
.el-select {
  margin-right: 10px;
}

.el-table {
  margin-top: 20px;
}

.el-pagination {
  margin-top: 20px;
  text-align: center;
}
</style>
